"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeSignaturesConcurrently = void 0;
const fs_1 = require("fs");
const hash_1 = require("./hash");
const common_1 = require("./common");
const pMap = require("p-map");
const { readFile } = fs_1.promises;
async function computeSignaturesConcurrently(paths) {
    return pMap(paths, async (path) => {
        const content = await readFile(path);
        return await hash_1.computeHash(path, content);
    }, { concurrency: common_1.HASHING_CONCURRENCY_LEVEL });
}
exports.computeSignaturesConcurrently = computeSignaturesConcurrently;
//# sourceMappingURL=signatures.js.map